import React from 'react';

import { Navigate, useParams } from 'react-router-dom';

import { Box, CircularProgress } from '@mui/material';

import useCurrentUser from '~/hooks/useCurrentUser';

import canShowTab from '~/utils/canShowTab';

import BusinessTabContent from './BusinessTabContent';
import { tabsMap } from './businessTabs';

export default function BusinessTabPage() {
  const { businessId, tab } = useParams<'businessId' | 'tab'>();
  const key = tab || 'business';
  const { user, isLoading } = useCurrentUser();

  if (isLoading || !user) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress aria-label="Checking business access" />
      </Box>
    );
  }

  const visibleTabs = Object.keys(tabsMap).filter((tabKey) => {
    const { requiredRoles } = tabsMap[tabKey];
    return !requiredRoles || canShowTab(user, requiredRoles);
  });

  if (!visibleTabs.includes(key)) {
    return <Navigate replace to={`/lebusiness/${businessId}/${visibleTabs[0]}`} />;
  }

  return <BusinessTabContent businessId={businessId} tab={key} visibleTabs={visibleTabs} />;
}
